import { render, staticRenderFns } from "./admin-setting-branch-form.vue?vue&type=template&id=6d3f4cf4"
import script from "./admin-setting-branch-form.vue?vue&type=script&lang=js"
export * from "./admin-setting-branch-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports